:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-column{flex-direction:column;}
:root ._pt-t-space-lar3169215{padding-top:var(--t-space-largest);}
:root ._pb-t-space-lar3169215{padding-bottom:var(--t-space-largest);}
:root ._pr-t-space-lar102228{padding-right:var(--t-space-larger);}
:root ._pl-t-space-lar102228{padding-left:var(--t-space-larger);}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._borderLeftColor-pressablePr1521563410{border-left-color:var(--pressablePrimaryBackground);}
:root ._borderLeftWidth-5px{border-left-width:5px;}
:root ._borderLeftStyle-solid{border-left-style:solid;}
:root ._borderLeftWidth-0px{border-left-width:0px;}
:root ._pos-absolute{position:absolute;}
:root ._r-t-space-sma3456{right:var(--t-space-small);}
:root ._t-t-space-med104641{top:var(--t-space-medium);}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._pr-t-space-med104641{padding-right:var(--t-space-medium);}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._pl-t-space-med104641{padding-left:var(--t-space-medium);}
:root ._z-2{z-index:2;}
:root ._cur-pointer{cursor:pointer;}
:root ._z-10{z-index:10;}
:root ._t-20px{top:20px;}
:root ._r-50px{right:50px;}
:root ._fd-row{flex-direction:row;}
:root ._items-center{align-items:center;}
:root ._width-10037{width:100%;}
:root ._btc-divider{border-top-color:var(--divider);}
:root ._btw-1px{border-top-width:1px;}
:root ._borderTopStyle-solid{border-top-style:solid;}
:root ._justify-center{justify-content:center;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._bg-backgroundM1654514607{background-color:var(--backgroundMutedBlock);}